import { Github } from 'lucide-react';
import GoogleButton, { googleConfigured } from './GoogleButton';
import { cn } from '../../lib/utils';

const API = import.meta.env.VITE_API_URL || '/api';
const githubOn = Boolean(import.meta.env.VITE_GITHUB_CLIENT_ID);
const microsoftOn = Boolean(import.meta.env.VITE_MICROSOFT_CLIENT_ID);

function MicrosoftIcon({ className }) {
  return (
    <svg viewBox="0 0 21 21" className={className} aria-hidden>
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

const oauthBtn =
  'flex h-11 w-full items-center justify-center gap-2.5 rounded-lg border border-white/15 bg-white/[0.03] text-sm font-medium text-content transition-colors hover:border-white/25 hover:bg-white/[0.07]';

/** Renders whichever social sign-in buttons are configured (+ an "or" divider). */
export default function SocialLogins({ onGoogle }) {
  if (!googleConfigured && !githubOn && !microsoftOn) return null;
  return (
    <div className="mb-5">
      <div className="space-y-2.5">
        {googleConfigured && <GoogleButton onCredential={onGoogle} />}
        {githubOn && (
          <button
            type="button"
            onClick={() => (window.location.href = `${API}/auth/github`)}
            className={cn(oauthBtn)}
          >
            <Github className="h-[18px] w-[18px]" /> Continue with GitHub
          </button>
        )}
        {microsoftOn && (
          <button
            type="button"
            onClick={() => (window.location.href = `${API}/auth/microsoft`)}
            className={cn(oauthBtn)}
          >
            <MicrosoftIcon className="h-[18px] w-[18px]" /> Continue with Microsoft
          </button>
        )}
      </div>
      <div className="my-5 flex items-center gap-3 text-xs text-content-subtle">
        <span className="h-px flex-1 bg-border/70" /> or <span className="h-px flex-1 bg-border/70" />
      </div>
    </div>
  );
}
